export const debounce = <A extends unknown[]>(
  callback: (...args: A) => void,
  timeout = 100,
): ((...args: A) => void) => {
  let timerId: number;

  return (...args: A) => {
    if (timerId) {
      window.clearTimeout(timerId);
    }

    timerId = window.setTimeout(() => callback(...args), timeout);
  };
};
